<template>
    <el-drawer v-model="authshow" size="30%" direction="rtl" :before-close="handleClose">

        <!-- 实名认证 -->
        <div class="auth-box" v-if="authinfo.auth_id==1">
            <div class="auth-box-item">
                <div class="auth-box-content-title">认证类型</div>
                <div class="auth-box-content left20">{{authinfo.auth_name}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">认证状态</div>
                <div class="auth-box-content left20">{{authinfo.verify_status}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">姓名</div>
                <div class="auth-box-content left20">{{authinfo.auth_id_name}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">身份证号</div>
                <div class="auth-box-content left20">{{authinfo.auth_id_card}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">提交时间</div>
                <div class="auth-box-content left20">{{authinfo.inputtime}}</div>
            </div>
        </div>

        <!-- 企业认证 -->
        <div class="auth-box" v-if="authinfo.auth_id==2">
            <div class="auth-box-item" style="display:inline-block">
                <wcimage :option="{size:'middle',showBig:true}" :value="item" v-for="(item,index) in authinfo.auth_business_license" :key="index" class="right10" style="margin-bottom:10px" />
            </div>
            <div class="auth-box-item top40">
                <div class="auth-box-content-title">认证类型</div>
                <div class="auth-box-content left20">{{authinfo.auth_name}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">认证状态</div>
                <div class="auth-box-content left20">{{authinfo.verify_status}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">认证失败原因</div>
                <div class="auth-box-content left20">{{authinfo.reason}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">主体名称</div>
                <div class="auth-box-content left20">{{authinfo.auth_business_shopname}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">主体类型</div>
                <div class="auth-box-content left20">{{authinfo.auth_business_shoptype}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">执照注册号</div>
                <div class="auth-box-content left20">{{authinfo.auth_business_node}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">联系电话</div>
                <div class="auth-box-content left20">{{authinfo.auth_business_phone}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">认证金额</div>
                <div class="auth-box-content left20">{{authinfo.auth_business_price}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">提交时间</div>
                <div class="auth-box-content left20">{{authinfo.inputtime}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">认证时效</div>
                <div class="auth-box-content left20">{{authinfo.auth_business_expiretime}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">微信支付订单号</div>
                <div class="auth-box-content left20">{{authinfo.transaction_id}}</div>
            </div>
            <div v-if="authinfo.status==0">
                <div class="auth-box-item top40">
                    <wcselect :option="{placeholder:'请选择认证类型',ischange:true,width:'200px',clearable:true,filterable:true}" 
                        :value="verifyparam.status"
                        :list="statuslists"
                        @finish="(val)=> {
                            verifyparam.status=val.value;
                        }"
                    />
                </div>
                <div class="auth-box-item top20" v-if="verifyparam.status==2">
                    <wcinput :option="{inputtype:'textarea',placeholder:'请输入认证失败原因',width:'300px',clearable:true,ischange:true,isinput:true}"
                        :value="verifyparam.reason"
                        @finish="(val)=> {
                            verifyparam.reason=val.value;
                        }"
                    />
                </div>
                <div class="auth-box-item top20" style="margin-bottom:50px">
                    <wcbutton :option="{title:'提交审核'}" @finish="verifySubmit"/>
                </div>
            </div>
        </div>


    </el-drawer>
</template>

<script>
import INTERFACE_MODEL_MEMBER from '@/Interface/Es/member';
export default {
    props:['view','data','status'],
    data() {
        return {
            authshow:false,
            authinfo:{},
            statuslists:[],
            verifyparam: {
                id:'',
                status:'',
                reason:'',
            },
        }
    },
    watch: {
        view(val){
            if(val) {
                this.authshow=true;
                this.authinfo=this.data;   
                this.statuslists=this.status; 
                this.verifyparam.id=this.data.id;
                this.verifyparam.status='';
                this.verifyparam.reason='';
            }
        },
    },
    mounted() {
        
    },
    methods: {

        /** 关闭窗口 **/
        handleClose() {
            this.authshow=false;
            this.$emit('finish');
        },

        /** 认证信息审核 **/
        verifySubmit() {
            INTERFACE_MODEL_MEMBER.AUTH_VERIFY(this.verifyparam).then((res) => {
                 if(res.status > 0) return false;
                 this.handleClose(); //关闭窗口
            });
        },



    },
}
</script>
<style scoped>
.auth-box {display: inline-block;width:100%;}
.auth-box-item {display: inline-flex;align-items: center;width:100%;position:relative;}
.auth-title {display: inline-flex;align-items: center;font-size:16px;font-weight: bold;}
.auth-title span {font-size:12px;line-height: 12px;color:#666666;padding:4px 10px;border-radius: 20px;border:1px solid #666666;font-weight: normal;}
.auth-status {color:#ffffff !important;background-color: #666eeb;border-color:#666eeb !important;}
.auth-box-content-title {display: inline-block;font-size:13px;color:#333333;width:25%;}
.auth-box-content {display: inline-block;font-size:13px;color:#333333;}
</style>